/** Actions names */
export const PLAY_TRACK = 'PLAY_TRACK';
export const PLAY_SOUND_EFFECT = 'PLAY_SOUND_EFFECT';
export const SEEK_TRACK = 'SEEK_TRACK';
export const SET_PLAYLIST = 'SET_PLAYLIST';
export const TRACK_PLAYING = 'TRACK_PLAYING';
export const TRACK_PAUSED = 'TRACK_PAUSED';

export const TRACK_LISTENING = 'TRACK_LISTENING';
export const SWITCH_RANDOM_MODE = 'SWITCH_RANDOM_MODE';
export const SWITCH_LOOP_MODE = 'SWITCH_LOOP_MODE';

/** Actions */

/**
 * Load the given track
 *
 * @param  {String} trackReference
 * @param  {String|null} versionReference
 * @param  {Number|null} startPosition
 * @param  {{offset: Number, duration: Number}[]} highlights
 *
 * @return {Object}
 */
export function playTrack(trackReference: string, versionReference: string | null = null, startPosition: number | null = null, highlights: { offset: number, duration: number }[] = []) {
  return { type: PLAY_TRACK, payload: { trackReference, versionReference, startPosition, highlights } };
}

/**
 * Load a Pro Sound Effects sound effect (preview).
 *
 * Sound effects are flat objects (not persisted on Miooz): the signed preview URL is played
 * directly, so this action short-circuits the `GetTrack` resolution used by {@link playTrack}.
 * All display metadata travels in the action — nothing is re-fetched from the server.
 *
 * @param  {{id: String, previewUrl: String, title: String, duration: Number, waveformDataUrl: ?String}} soundEffect
 *
 * @return {Object}
 */
export function playSoundEffect(soundEffect) {
  return { type: PLAY_SOUND_EFFECT, payload: { soundEffect } };
}

/**
 * Seek the currently playing track to the given position
 *
 * @param  {Number|null} offset
 *
 * @return {Object}
 */
export function seekTrack(offset: number | null = null) {
  return { type: SEEK_TRACK, payload: { offset } };
}

/**
 * Play current track
 *
 * @return {Object}
 */
export function play() {
  return { type: TRACK_PLAYING };
}

/**
 * Pause the current track
 *
 * @return {Object}
 */
export function pause() {
  return { type: TRACK_PAUSED };
}

/**
 * Set current playlist
 *
 * @param {Array|null} playlist
 */
export function setPlaylist(playlist: unknown[] | null = null) {
  return { type: SET_PLAYLIST, payload: { playlist } };
}

/**
 * Switch on/off random mode
 *
 * @return {Object}
 */
export function switchRandomMode() {
  return { type: SWITCH_RANDOM_MODE };
}

/**
* Switch on/off loop mode
*
* @return {Object}
*/
export function switchLoopMode() {
  return { type: SWITCH_LOOP_MODE };
}
